// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__29b5u","header":"ReportDetails_header__2RfFm","title":"ReportDetails_title__Lrm-Q","left":"ReportDetails_left__3KrD0"};